// import Axios from 'axios';

const state = () => ({
  faqs: [],
});
const mutations = {
  SET_EVENTS(state, payload) {
    state.events = payload;
  },
};
const actions = {
  getFaq() {
    return ['asds'];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
